import React from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { getContext } from '@fiverr-private/fiverr_context';
import { BriefItem } from '../../../../../lib/types/brief';
import { getCreatedByUserName } from '../../../../../lib/utils/getters';
import { formatTimestamp } from '../../../../../lib/utils/time';
import { BriefTitle } from './BriefTitle';

interface TitleProps {
  row: Row<BriefItem>;
}

export const Title: React.FC<TitleProps> = ({ row }: TitleProps) => {
  const { organizationId } = getContext();

  return (
    <Stack direction="column" gap="1">
      <BriefTitle row={row} />
      <Stack direction="row" alignItems="center" gap="1">
        <Text size="b_sm" color="bodySecondary">
          {formatTimestamp(row.original.createdAt)}
        </Text>
        {!!organizationId && (
          <>
            <Box width="3px" height="3px" borderRadius="circle" backgroundColor="grey_900" />
            <Text size="b_sm" color="bodySecondary">
              {getCreatedByUserName(row.original.createdBy)}
            </Text>
          </>
        )}
      </Stack>
    </Stack>
  );
};
